

















































import { Component, Vue, Prop, Model } from "vue-property-decorator";
import Checkbox from "./Checkbox.vue";
import ComboBox from "./ComboBox.vue";
import RadioButton from "./RadioButton.vue";
import Textarea from "./Textarea.vue";

@Component({
  components: {
    appRadioButton: RadioButton,
    appTextarea: Textarea,
    appComboBox: ComboBox,
    appCheckbox: Checkbox
  }
})
export default class Question extends Vue {
  @Model("change") readonly value!: any;
  @Prop({ required: true }) readonly title!: string;
  @Prop({ default: "" }) readonly subtitle!: string;
  @Prop({ type: Boolean, required: true }) readonly required!: boolean;
  @Prop({
    required: true,
    validator: (value: string) =>
      ["meh", "mev", "open", "dropdown", "checkbox"].includes(value)
  })
  readonly type!: string;
  @Prop({ default: null }) readonly options?: object[] | null;
}
